import { Group } from '@/router/group.model';
import {
  allActivities,
  customersList,
  coinsPurchased,
  rewardedCoins,
  discountsActivities
} from '@/router/routes';

const routes = [
  allActivities,
  customersList,
  coinsPurchased,
  rewardedCoins,
  discountsActivities
];

const reportsGroup = new Group('Reports', 'reports', routes, {
  superRoot: false
});

export { reportsGroup };
export default reportsGroup;
